import { useState } from "react";
import { Timer, Clock, Dog, ChevronDown } from "lucide-react";
import { OpsSectionHead } from "@/components/OpsSectionHead";

const etMinutesNow = () => {
  const [h, m] = new Date().toLocaleTimeString("en-GB", { timeZone: "America/New_York", hour12: false }).split(":").map(Number);
  return h * 60 + m;
};
const toMin = (t) => {
  const m = /^(\d{1,2}):(\d{2})/.exec(t || "");
  return m && t !== "00:00" ? Number(m[1]) * 60 + Number(m[2]) : null;
};
const fmt12 = (t) => {
  const v = toMin(t);
  if (v == null) return "Today";
  const h = Math.floor(v / 60), mm = String(v % 60).padStart(2, "0");
  return `${((h + 11) % 12) + 1}:${mm} ${h < 12 ? "AM" : "PM"}`;
};

// Going Home → owners picking up within the next 60 minutes (Eastern time), soonest first.
export const leavingSoon = (groups, windowMin = 60) => {
  const now = etMinutesNow();
  return groups
    .map((g) => ({ g, t: toMin(g.checkout_time) }))
    .filter(({ g, t }) => t != null && t >= now - 15 && t <= now + windowMin && g.animals.some((a) => !a.has_left))
    .sort((a, b) => a.t - b.t)
    .map(({ g }) => g);
};

export const LeavingSoon = ({ groups }) => {
  const [open, setOpen] = useState(false);
  const soon = leavingSoon(groups);
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 mb-4 space-y-3" data-testid="gh-leaving-soon">
      <button type="button" className="w-full text-left" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="gh-leaving-soon-toggle">
        <OpsSectionHead icon={Timer} title="Leaving soon" sub="Owners picking up in the next 60 minutes — get these dogs ready first"
          right={<>
            <span className="v3-num text-sm font-bold text-gray-900" data-testid="gh-leaving-soon-count">{soon.length}</span>
            <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#1F8A7C]">
              {open ? "Collapse" : "Expand"}
              <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
            </span>
          </>} />
      </button>
      {open && (soon.length === 0 ? (
        <div className="text-sm text-gray-500 py-2" data-testid="gh-leaving-soon-empty">No pickups in the next hour.</div>
      ) : (
        <div className="divide-y divide-gray-100" data-testid="gh-leaving-soon-list">
          {soon.map((g) => (
            <div key={g.owner_key} className="flex items-center gap-3 py-2 flex-wrap" data-testid={`gh-soon-${g.owner_key}`}>
              <span className="v3-num text-sm font-bold text-gray-900 w-20 inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5 text-gray-400" />{fmt12(g.checkout_time)}</span>
              <span className="font-semibold text-gray-900 inline-flex items-center gap-1.5"><Dog className="h-4 w-4 text-gray-400" />{g.animals.map((a) => a.animal_name).join(", ")}</span>
              <span className="text-sm text-gray-500">{g.owner_name}</span>
              {g.animals[0]?.room && <span className="v3-num text-xs text-gray-500 ml-auto">{g.animals[0].room}</span>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
